import { render, staticRenderFns } from "./BasicContent.vue?vue&type=template&id=d2ccd15a&scoped=true&"
import script from "./BasicContent.vue?vue&type=script&lang=js&"
export * from "./BasicContent.vue?vue&type=script&lang=js&"
import style0 from "./BasicContent.vue?vue&type=style&index=0&id=d2ccd15a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ccd15a",
  null
  
)

export default component.exports